type CarouselHeroItemProps = {
  images: Images[]
  pillgroups: PillGroupItem[][]
}

interface Images {
  alt: string
  src: string
}

interface PillGroupItem {
  src: string
  side: 'left' | 'right'
}

export const carouselHeroData: CarouselHeroItemProps = {
  images: [
    {
      alt: 'AI analytics assistant dashboard',
      src: '/images/pages/home/carousel-pipeline-screen-1.webp',
    },
    {
      alt: 'Shipping analytics overview dashboard',
      src: '/images/pages/home/carousel-pipeline-screen-2.webp',
    },
    {
      alt: 'Revenue analytics overview dashboard',
      src: '/images/pages/home/carousel-pipeline-screen-3.webp',
    },
  ],

  pillgroups: [
    [
      { src: '/images/pages/embedded-analytics/flows-pill.svg', side: 'left' },
      {
        src: '/images/pages/embedded-analytics/retention-pill.svg',
        side: 'right',
      },
    ],
    [
      { src: '/images/pages/embedded-analytics/orders-pill.svg', side: 'left' },
      { src: '/images/pages/embedded-analytics/state-pill.svg', side: 'right' },
    ],
    [
      { src: '/images/pages/embedded-analytics/ROI-pill.svg', side: 'left' },
      {
        src: '/images/pages/embedded-analytics/signups-pill.svg',
        side: 'right',
      },
    ],
  ],
}
